class PaginationLabel extends HTMLElement {
  constructor () {
    super()

    this.state = {
      root: window.theme.tagalys.results.stateLayer.state,
    }

    this.pageCount = 0

    // Store bound handlers for cleanup
    this._boundHandlers = {
      handleProductsUpdated: products => {
        if (products.length > 0) {
          this.render()
        } else {
          this.classList.add('hidden')
        }
      },
      handleSortUpdated: () => {
        this.pageCount = 0
      },
    }
  }

  connectedCallback () {
    this.subscribeToEvents()
  }

  disconnectedCallback () {
    this.unsubscribeFromEvents()
  }

  subscribeToEvents () {
    window.theme.tagalys.results.eventBus.subscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )

    window.theme.tagalys.results.eventBus.subscribe(
      'results:ui:sort:changed',
      this._boundHandlers.handleSortUpdated,
    )
  }

  unsubscribeFromEvents () {
    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:state:products:updated',
      this._boundHandlers.handleProductsUpdated,
    )

    window.theme.tagalys.results.eventBus.unsubscribe(
      'results:ui:sort:changed',
      this._boundHandlers.handleSortUpdated,
    )
  }

  render () {
    const { pagination } = this.state.root
    this.pageCount = this.pageCount + 1

    if (pagination.page === undefined) {
      this.setAttribute('hidden', '')
      return
    }

    const end = Math.min(this.pageCount * pagination.size, pagination.total)

    this.innerHTML = ''
    this.insertAdjacentHTML('beforeend', `${end} of ${pagination.total}`)
  }
}

customElements.define('pagination-label', PaginationLabel)
